<fc-progress-bar currentStep="4"></fc-progress-bar>
<div class="container">
  <header class="page-header">
    <div class="fc-back-link" data-cy="button-back" [routerLink]="['/site', activeSite?.id, 'site-offer']">
      <fa-icon [icon]="['far', 'arrow-left']" class="size-20"></fa-icon>
      <span>Back</span>
    </div>
    <div class="header-text">
      Thanks! Please answer some questions so we can ensure that the selected stands are eligible for submission.
    </div>
    <mat-divider></mat-divider>
  </header>

  <div *ngIf="activeSite" class="main-container">
    <main class="step-review">
      <div class="review-panel">
        @if (!invalidAnsweredQuestions) {
          <div class="header">STANDS ELIGIBILITY QUESTIONS</div>
          <div class="header-info">Please answer the following questions based on the stands you selected.</div>
        } @else {
          <div class="header error">WE'RE SORRY</div>
          <div class="header-info error">
            Your selection is not eligible for a carbon offset site based on your answers to the following questions:
          </div>
        }
        <fc-report-form
          [redProgramFlag]="redProgramFlag"
          [activeSite]="activeSite"
          [eligibilityForm]="eligibilityForm"
          [reportConfig]="reportConfig"
          (selectedProgramsChange)="selectProgram($event)"
          [docFiles]="docFiles"
          [currentUser]="currentUser"></fc-report-form>
        @if (invalidAnsweredQuestions) {
          <div class="edit-stand-message">
            If you wish to change your stand selection so that your answers to these eligibility questions qualify, you
            may do so at this time.
          </div>
        }
      </div>

      <div class="eligibility-side-panel">
        <div class="side-header">
          <h2>Your Carbon Offset Site</h2>
        </div>
        <div *ngFor="let selectedStand of selectedStandList; let i = index">
          <fc-site-stand-item
            [allowRemove]="false"
            [clickable]="false"
            [cohortId]="this.activeSite.cohort.id"
            [index]="i"
            [stand]="selectedStand"></fc-site-stand-item>
        </div>
      </div>
    </main>
    <div class="button-area">
      <button
        (click)="onSubmit()"
        [class.disabled]="eligibilityForm.invalid"
        [disabled]="eligibilityForm.invalid"
        class="button-next"
        color="primary"
        data-cy="button-next"
        mat-raised-button>
        Next
      </button>
    </div>
  </div>
</div>
